jQuery(function($) {
  function reveal() {
    $('.animicon, .spotlight-wrap .green-brow, .green-brow-wide, .spotlight-wrap .spotlight, .video-spotlight-content .h3, .filter-resource-spotlight .testimonies, .card-wrap, .page-content h2, .firstresult').each(function() {
      var hT = $(this).offset().top,
          wH = $(window).height() * 0.75;

      if (hT < wH) {
        $(this).addClass('unhidden');
      }
    });
  }

  reveal();

  $('body').scroll(function() {
    reveal();
  });
});
